
function getOptionsGenerators(method, data = null) {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return options;
}

// Método para realizar la solicitud
function generatorRequest(url, options) {
  return fetch(`http://127.0.0.1:5000${url}`, options)
    .then((res, error) => {
      return res;
    })
    .catch((err) => err);
}


export const POST = (url, data) => {
  const options = getOptionsGenerators("POST", data);
  return generatorRequest(url, options);
}
